import { defineFilterSpec, enumField, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { InstallationFilterFormValues, InstallationListFilters } from './types';

/** Single declaration of the installation list filters, shared by api/drawer/page. Multi-selects
 *  join to comma strings on the wire (AND across fields); date bounds pass through as strings. */
const spec = defineFilterSpec<InstallationListFilters, InstallationFilterFormValues>([
  text('search'),
  multiField('statuses'),
  multiField('assigneeIds'),
  multiField('assigneeTypes'),
  rangeField('deviceCount'),
  enumField('orderDateFrom'),
  enumField('orderDateTo'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
